import { useQueryWithStore } from "react-admin";

const usePage = (name, params = {}, defaults = {}) => {
  const { data, loaded } = useQueryWithStore({
    type: "get",
    resource: "website",
    payload: {
      method: `${name}Page`,
      ...params,
    },
  });
  return loaded ? data : defaults;
};
export default usePage;
